import fetch from 'cross-fetch'
import cookies from './cookies'
import { logout } from '../actions/auth.action'
import { updateTimer, removeTimer } from '../actions/session.action'

const baseUrl = process.env.REACT_APP_BASE_API_URL

const callApi = (url: string, method: string, body: any = {}, extraHeaders: any = {}) => {
	let params = {
		method,
		headers: {
            'Content-Type': 'application/json',
			'authorization-token': cookies.load('authToken'),
			'authorization': process.env.REACT_APP_AUTHORIZATION_HEADER,
			...extraHeaders
		},
		body
	}
	if (params.method === 'GET') {
		delete params.body
		delete params.headers['Content-Type']
	}
	if (params.headers['Content-Type'] === 'application/json') params.body = JSON.stringify(params.body)

	return (dispatch: any, timeout: boolean = false, withoutAuth: boolean = false) => {
		dispatch(updateTimer())
		return new Promise((resolve, reject) => {
			if (!withoutAuth && !cookies.load('authToken')) {
				dispatch(logout())
				reject(new Error('Unauthorized!'))
			}
			if (timeout) setTimeout(() => reject(new Error('Connection Timeout!')), 30 * 1000)
			fetch(baseUrl + url, params).then(resolve, reject)
		})
			.then((res: any) => {
				if (res.ok || res.status === 401 || res.status === 403) {
					if (res.status === 401 || res.status === 403) {
						dispatch(logout())
						dispatch(removeTimer())
					}
					return res.json()
				}
				else throw new Error(res.status === 500 ? 'Something went wrong! Please try again leter' : res.status === 429 ? 'Too many requests! Plaese try again leter' : res.statusText)
			})
			.then(res => {
				if (res.data) {
                    return res.data
                } else if (res.error) {
					let msg = res.error?.messages && res.error?.messages[0]
					throw new Error(msg)
				} else throw new Error(res.status)
			})
			.catch(err => {
				throw new Error(err.message)
			})
	}
}


export default {
	get: (url: string, extraHeaders?: any) => callApi(url, 'GET', {}, extraHeaders),
	post: (url: string, body?: any, extraHeaders?: any) => callApi(url, 'POST', body, extraHeaders),
	put: (url: string, body?: any, extraHeaders?: any) => callApi(url, 'PUT', body, extraHeaders),
	patch: (url: string, body?: any, extraHeaders?: any) => callApi(url, 'PATCH', body, extraHeaders),
	delete: (url: string, body?: any, extraHeaders?: any) => callApi(url, 'DELETE', body, extraHeaders),
}